import axios from "axios";
import config from "@/config";

export default {
  getPayrollDoc(search, branch, department, page) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/salaryplan/getDoc`, {
      params: {
        s: search,
        branch: branch,
        department: department,
        page: page,
        order: "DESC",
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
    createPayrollDocOptimized(user_code, doc_no, doc_date, start_date, end_date, branch, dep, remark, result_data,data_by_branch, period_date) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });

    var datax = {
      result_data: result_data,
      data_by_branch: JSON.stringify(data_by_branch),
    }

    return http.post(`/salaryplan/optimized-payroll/create-doc`, datax, {
      params: {
        emp_code: user_code,
        doc_no: doc_no,
        doc_date: doc_date,
        start_date: start_date,
        end_date: end_date,
        branch: branch,
        dep: dep,
        remark: remark,
        creator_code: localStorage._usercode,
        period_date: period_date,
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },

  createPayrollDoc(user_code, doc_no, doc_date, start_date, end_date, branch, dep, remark, result_data,period_date) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.post(`/salaryplan/createdocandbranch`,JSON.stringify(result_data) , {
      params: {
        emp_code: user_code,
        doc_no: doc_no,
        doc_date: doc_date,
        start_date: start_date,
        end_date: end_date,
        branch: branch,
        period_date: period_date,
        dep: dep,
        remark: remark,
        creator_code: localStorage._usercode,
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  postSendEmail(data) {
    const http = axios.create({
      baseURL: "https://mailsender.cocopayday.com",
    });
    return http.post(`/`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  getPayrollDetailByDocNoPage(doc_no,offset,limit) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/salaryplan/getDocDetailPage`, {

      params: {
        doc_no: doc_no,
        companyid: _company_guid,
        offset:offset,
        limit:limit
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getPayrollDetailByDocNo(doc_no) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/salaryplan/getDocDetail`, {

      params: {
        doc_no: doc_no,
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getDocDetailByEmp(emp_code) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/salaryplan/getDocDetailByEmp`, {
      params: {
        emp_code: emp_code,
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getsilpPayroll(doc_no, emp_code) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/salaryplan/getDocDetailPrint`, {
      params: {
        doc_no: doc_no,
        code: emp_code,
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  deleteListPayRollDocNo(doc_no) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.delete(`/salaryplan/delpayroll/` + doc_no, {
      params: {
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
  getDocDetailPrint(doc_no, code) {
    const _token = localStorage._token;
    const _company_guid = localStorage._company_guid;
    const http = axios.create({
      baseURL: config.API_URL,
    });
    return http.get(`/salaryplan/getDocDetailPrint`, {
      params: {
        doc_no: doc_no,
        code: code,
        companyid: _company_guid,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _token,
        "X-TenantID": _company_guid,
      },
    });
  },
};
